export enum VisitsColorEnum {
  blue = 'blue',
  green = 'green',
}
